
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import nsa829c40abeda773929394ed948ee8653en from './en.yaml'
            i18n.addResourceBundle('en', 'a829c40abeda773929394ed948ee8653', flattenObject(nsa829c40abeda773929394ed948ee8653en), true, true);
        
        export default 'a829c40abeda773929394ed948ee8653';
    